import { type i18n } from 'i18next';
import { OverviewData } from './Overview.types';
import { AdDetails } from '@/api/types/ads.types';
import { getMessageTime } from '@/utils/datetime.utils';

export const getOverviewData = (
  i18n: i18n,
  adDetails: AdDetails
): OverviewData[] => {
  const { legacyResourceId, hits } = adDetails;
  return [
    { id: 1, name: '№', value: legacyResourceId },
    {
      id: 2,
      value: getMessageTime(new Date(adDetails.updatedAt), i18n, true),
      isDateTime: true,
    },
    { id: 3, name: `${i18n.t('pages.ad.views')}:`, value: hits },
  ];
};
